import { createSlice } from "@reduxjs/toolkit";

let initialFormComponents = [
  {
    stepName: "Request",
    stepTabLabel: "Request",
    stepTabVisible: true,
    stepTabEnabled: true,
    stepCompleted: false,
  },
  {
    stepName: "Personalize",
    stepTabLabel: "Personalize",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "Recipient",
    stepTabLabel: "Recipient",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "Return",
    stepTabLabel: "Return",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "EcardRecipient",
    stepTabLabel: "Recipient",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "Approve",
    stepTabLabel: "Approve",
    stepTabVisible: false,
    stepTabEnabled: false,
    stepCompleted: false,
  },
  {
    stepName: "AddToCart",
    stepTabLabel: "Add to Cart",
    stepTabVisible: true,
    stepTabEnabled: false,
    stepCompleted: false,
  },
];

const configureStepComponents = (
  Id,
  cardTypeValue,
  formStepComponents,
  currentStepName = ""
) => {
  if (cardTypeValue !== "nocard") {
    // is not a no card
    formStepComponents[5].stepTabVisible = true; // show approve tab
    if (cardTypeValue === "ecard") {
      // is ecard
      formStepComponents[1].stepTabVisible = true; // show personalize tab
      formStepComponents[4].stepTabVisible = true; // show ecard tab
    } else {
      if (cardTypeValue === "sendtome") {
        // is send to me
        formStepComponents[2].stepTabVisible = true; // show recipient tab
      } else {
        // is send to someone
        formStepComponents[1].stepTabVisible = true; // show personalize tab
        formStepComponents[2].stepTabVisible = true; // show recipient tab
        formStepComponents[3].stepTabVisible = true; // show return tab
      }
    }
  } else {
  }

  if (currentStepName) {
    let markedCompleted = false;
    for (const i in formStepComponents) {
      let step = formStepComponents[i];
      if (
        formStepComponents[i].stepName !== currentStepName &&
        !markedCompleted
      ) {
        formStepComponents[i].stepCompleted = true;
        formStepComponents[i].stepTabEnabled = true;
      } else {
        markedCompleted = true;
      }
    }
  }

  if (Id) {
    // override defaults if existing cart item
    formStepComponents[6].stepTabLabel = "Update Cart";
  }

  return formStepComponents;
};

const getNextConfiguratorStep = (currentStep, cardTypeValue) => {
  let nextStep = "";
  if (currentStep === "Request") {
    if (cardTypeValue === "nocard") {
      nextStep = "AddToCart";
    } else {
      if (cardTypeValue === "sendtome") {
        nextStep = "Recipient";
      } else {
        nextStep = "Personalize";
      }
    }
  } else if (currentStep === "Personalize") {
    if (cardTypeValue === "ecard") {
      nextStep = "EcardRecipient";
    } else {
      nextStep = "Recipient";
    }
  } else if (currentStep === "Recipient") {
    if (cardTypeValue === "sendtosomeone") {
      nextStep = "Return";
    } else {
      nextStep = "Approve";
    }
  } else if (currentStep === "EcardRecipient" || currentStep === "Return") {
    nextStep = "Approve";
  } else if (currentStep === "Approve") {
    nextStep = "AddToCart";
  }

  return nextStep;
};

const setNextStepProgress = (state) => {
  let newFormStep = getNextConfiguratorStep(
    state.FormStep,
    state.ConfiguratorRequest.DonorRequest.CardTypeValue
  );
  state.FormStep = newFormStep;
  let formStepComponents = initialFormComponents.map((item) => {
    return { ...item };
  });
  state.FormStepComponents = configureStepComponents(
    state.ConfiguratorRequest.DonorRequest.Id,
    state.ConfiguratorRequest.DonorRequest.CardTypeValue,
    formStepComponents,
    newFormStep
  );
};

const configuratorSlice = createSlice({
  name: "configurator",
  initialState: {
    Loaded: false,
    AddingToCart: false,
    FormStep: "Request",
    ConfiguratorRequest: {
      DonorRequest: {},
      CurrentProduct: "nocard",
    },
    FormStepComponents: initialFormComponents,
  },
  reducers: {
    setInitialState: (state, action) => {
      let pageDefaults = action.payload.pageDefaults;
      let initialRequest = action.payload.request;
      let productType = "nocard";

      // set defaults based on page/widget properties or cart data (if available)
      if (initialRequest.DonorRequest.Id) {
        if(initialRequest.DonorRequest.DoNotSignCard == 'False') initialRequest.DonorRequest.DoNotSignCard = false;
        if (initialRequest.DonorRequest.CardTypeValue !== "nocard") {
          productType = "card";
        }
      } else {
        initialRequest.DonorRequest.CardTypeValue = pageDefaults.cardType;
        initialRequest.DonorRequest.Occasion = pageDefaults.occasion;

        if (pageDefaults.cardType !== "nocard") {
          productType = "card";
        }
      }

      initialRequest.CurrentProduct = productType;

      if (initialRequest.DonorRequest.Id) {
        // override defaults if existing cart item
        state.FormStepComponents[6].stepTabLabel = "Update Cart";
      }

      // configure steps and form components based on defaults
      let formStepComponents = initialFormComponents.map((item) => {
        return { ...item };
      });
      state.FormStepComponents = configureStepComponents(
        initialRequest.DonorRequest.Id,
        initialRequest.DonorRequest.CardTypeValue,
        formStepComponents
      );

      state.Loaded = true;
      state.FormStep = "Request";
      state.ConfiguratorRequest = initialRequest;
    },
    setFormStep: (state, action) => {
      let formStepComponents = initialFormComponents.map((item) => {
        return { ...item };
      });
      state.FormStepComponents = configureStepComponents(
        state.ConfiguratorRequest.DonorRequest.Id,
        state.ConfiguratorRequest.DonorRequest.CardTypeValue,
        formStepComponents,
        action.payload
      );
      state.FormStep = action.payload;
    },
    setIntention(state, action) {
      state.ConfiguratorRequest.DonorRequest.Intention = action.payload;
    },
    setCardQuantity(state, action) {
      state.ConfiguratorRequest.DonorRequest.CardQuantity = action.payload;
    },
    setCardType(state, action) {
      // update current product and price
      let productType = action.payload;
      if (action.payload !== "nocard") {
        if(action.payload === 'sendtome') {
          productType = "cards";
        } else {
          productType = "card";
        }
      }

      state.ConfiguratorRequest.CurrentProduct = productType;

      // update card type
      state.ConfiguratorRequest.DonorRequest.CardTypeValue = action.payload;
      

      // update ui based on card type
      let formStepComponents = initialFormComponents.map((item) => {
        return { ...item };
      });
      state.FormStepComponents = configureStepComponents(
        state.ConfiguratorRequest.DonorRequest.Id,
        state.ConfiguratorRequest.DonorRequest.CardTypeValue,
        formStepComponents
      );
    },
    setRequest(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      // request
      state.ConfiguratorRequest.DonorRequest.CardTypeValue =
        submittedValues.cardType;
      state.ConfiguratorRequest.DonorRequest.Intention =
        submittedValues.intention;
      if (submittedValues.amount === "other") {
        state.ConfiguratorRequest.DonorRequest.OfferingAmount =
          submittedValues.customAmount;
      } else {
        state.ConfiguratorRequest.DonorRequest.OfferingAmount =
          submittedValues.amount;
      }

      state.ConfiguratorRequest.DonorRequest.CardQuantity = submittedValues.cardQuantity;

      // update ui for new step if card
      if (state.ConfiguratorRequest.DonorRequest.CardTypeValue !== "nocard") {
        state.AddingToCart = false;
        setNextStepProgress(state);
      } else {
        state.AddingToCart = true;
      }
    },
    setPersonalize(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      state.ConfiguratorRequest.DonorRequest.CardSignature =
        submittedValues.cardSignature;
      state.ConfiguratorRequest.DonorRequest.MailDate =
        submittedValues.mailDate;

      // update ui for new step
      setNextStepProgress(state);
    },
    setRecipient(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      state.ConfiguratorRequest.DonorRequest.SendTo = submittedValues.sendTo;
      state.ConfiguratorRequest.DonorRequest.RecipientTitle =
        submittedValues.title;
      state.ConfiguratorRequest.DonorRequest.RecipientFirstName =
        submittedValues.firstName;
      state.ConfiguratorRequest.DonorRequest.RecipientLastName =
        submittedValues.lastName;
      state.ConfiguratorRequest.DonorRequest.RecipientAddress1 =
        submittedValues.address1;
      state.ConfiguratorRequest.DonorRequest.RecipientAddress2 =
        submittedValues.address2;
      state.ConfiguratorRequest.DonorRequest.RecipientCountry =
        submittedValues.country;
      if (submittedValues.country === "USA") {
        state.ConfiguratorRequest.DonorRequest.RecipientStateProvince =
          submittedValues.state;
      } else if (submittedValues.country === "Canada") {
        state.ConfiguratorRequest.DonorRequest.RecipientStateProvince =
          submittedValues.province;
      }
      state.ConfiguratorRequest.DonorRequest.RecipientCity =
        submittedValues.city;
      state.ConfiguratorRequest.DonorRequest.RecipientZipPostalCode =
        submittedValues.postalCode;

      // update ui for new step
      setNextStepProgress(state);
    },
    setEcardRecipient(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      state.ConfiguratorRequest.DonorRequest.EcardSendToFirstName =
        submittedValues.ecardSendToFirstName;
      state.ConfiguratorRequest.DonorRequest.EcardSendToLastName =
        submittedValues.ecardSendToLastName;
      state.ConfiguratorRequest.DonorRequest.EcardEmail =
        submittedValues.emailAddress;
      state.ConfiguratorRequest.DonorRequest.EcardName =
        submittedValues.ecardName;

      // update ui for new step
      setNextStepProgress(state);
    },
    setUseAddressValue(state, action) {
      state.ConfiguratorRequest.DonorRequest.UseAddress = action.payload;
    },
    setReturn(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      state.ConfiguratorRequest.DonorRequest.UseAddress =
        submittedValues.useAddress;
      state.ConfiguratorRequest.DonorRequest.ReturnTitle =
        submittedValues.useAddress !== "none" ? submittedValues.title : "";
      state.ConfiguratorRequest.DonorRequest.ReturnFirstName =
        submittedValues.useAddress !== "none" ? submittedValues.firstName : "";
      state.ConfiguratorRequest.DonorRequest.ReturnLastName =
        submittedValues.useAddress !== "none" ? submittedValues.lastName : "";
      state.ConfiguratorRequest.DonorRequest.ReturnAddress1 =
        submittedValues.useAddress !== "none" ? submittedValues.address1 : "";
      state.ConfiguratorRequest.DonorRequest.ReturnAddress2 =
        submittedValues.useAddress !== "none" ? submittedValues.address2 : "";
      state.ConfiguratorRequest.DonorRequest.ReturnCountry =
        submittedValues.useAddress !== "none" ? submittedValues.country : "";
      if (submittedValues.country === "USA") {
        state.ConfiguratorRequest.DonorRequest.ReturnStateProvince =
          submittedValues.useAddress !== "none" ? submittedValues.state : "";
      } else if (submittedValues.country === "Canada") {
        state.ConfiguratorRequest.DonorRequest.ReturnStateProvince =
          submittedValues.useAddress !== "none" ? submittedValues.province : "";
      }
      state.ConfiguratorRequest.DonorRequest.ReturnCity =
        submittedValues.useAddress !== "none" ? submittedValues.city : "";
      state.ConfiguratorRequest.DonorRequest.ReturnZipPostalCode =
        submittedValues.useAddress !== "none" ? submittedValues.postalCode : "";

      // update ui for new step
      setNextStepProgress(state);
    },
    setApprove(state, action) {
      // add/update to cart, get cart item id, update mini cart count
      state.AddingToCart = false;
      state.ConfiguratorRequest.DonorRequest.Id = action.payload;
      setNextStepProgress(state);
    },
    setLoggedInDonor: (state, action) => {
      state.ConfiguratorRequest.DonorIsLoggedIn = true;
      state.ConfiguratorRequest.DonorInfo.Title = action.payload.donorInfo.title;
      state.ConfiguratorRequest.DonorInfo.FirstName = action.payload.donorInfo.firstName;
      state.ConfiguratorRequest.DonorInfo.LastName = action.payload.donorInfo.lastName;
      state.ConfiguratorRequest.DonorInfo.Address1 = action.payload.donorInfo.address1;
      state.ConfiguratorRequest.DonorInfo.Address2 = action.payload.donorInfo.address2;
      state.ConfiguratorRequest.DonorInfo.Country = action.payload.donorInfo.country;
      state.ConfiguratorRequest.DonorInfo.StateProvince = action.payload.donorInfo.stateProvince;
      state.ConfiguratorRequest.DonorInfo.City = action.payload.donorInfo.city;
      state.ConfiguratorRequest.DonorInfo.PostalCode = action.payload.donorInfo.postalCode;
    },
  },
});

export const configuratorActions = configuratorSlice.actions;

export default configuratorSlice;
